import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  theme => ({
    header: {
      backgroundColor: theme.colors.gray1,
      padding: '5px 13px 5px 15px',
      border: '1px solid',
      borderColor: theme.colors.gray5,
      boxShadow: ' 0px 2px 0px 0px #00000004',
      borderRadius: theme.borderRadius.min,
      ...theme.typography.body2,
      '&:hover': {
        cursor: 'pointer',
        borderColor: theme.colors.mainGreen5,
      },
    },
    noborderHeader: {
      border: 'none',
      padding: '5px 8px',
      ...theme.typography.body2,
      color: theme.colors.captionColor,
      fontWeight: 600,
      ...theme.flex.crossCenter,
      '&:hover': {
        cursor: 'pointer',
        background: theme.colors.gray3,
      },
    },

    selectColor: {
      color: `${theme.colors.mainGreen6} !important`,
    },
    homeSvg: {
      marginRight: '7px',
    },
    plotSvg: {
      width: '13px',
      marginRight: '9px',
      color: theme.colors.gray10,
      verticalAlign: 'middle',
      fill: theme.colors.bodyColor,
    },
    ploSvgFill: {
      fill: theme.colors.mainGreen6,
    },
    downSvg: {
      verticalAlign: 'middle',
      marginLeft: '8px',
      fontSize: '8px !important',
    },
    searchBox: {
      position: 'relative',
      display: 'inline-block',
      marginRight: '8px',
    },
    filterTable: {
      backgroundColor: theme.colors.gray1,
      borderRadius: theme.borderRadius.min,
      display: 'block',
      position: 'absolute',
      boxShadow: '0px 9px 28px 8px #0000000D',
      top: '37px',
      zIndex: 3,

      '& .ant-checkbox-group': {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    hideFilterBox: {
      display: 'none',
    },
    bottomBox: {
      ...theme.flex.center,
      justifyContent: 'space-between',
      borderTop: '1px solid #E8E8E8',
      padding: '10px 12px',
    },
    resetBtn: {
      cursor: 'pointer',
      fontSize: '12px',
      lineHeight: '22px',
      border: 'none',
      marginRight: '12px',
      borderRadius: '2px',
      paddingLeft: '8px',
      paddingRight: '8px',
      '&:hover': {
        backgroundColor: theme.colors.gray3,
      },
    },
    okbtn: {
      cursor: 'pointer',
      border: 'none',
      padding: '1px 8px',
      background: '#38B2A6',
      fontSize: '12px',
      lineHeight: '22px',
      color: theme.colors.gray1,
      borderRadius: '2px',
      ...theme.flex.center,
    },
    disabledbtn: {
      color: theme.colors.disableColor,
      cursor: 'not-allowed',
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
    filterSvg: {
      fontSize: '12px',
      color: '#9E9E9E',
      marginLeft: '8px',
    },
    svgRotate: {
      transform: 'rotateX(180deg)',
      transformOrigin: 'center',
    },
    highLight: {
      color: '#38b2a6',
    },

    loadingbox: {
      width: '240px',
      height: '200px',
      position: 'relative',
      textAlign: 'center',
      '&.ant-spin-spinning': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      },
    },
    radioGroupTitle: {
      display: 'block',
      margin: '0',
      paddingLeft: '12px',
      paddingTop: '4px',
      paddingBottom: '4px',
      fontSize: '14px',
      lineHeight: '22px',
      maxWidth: '240px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      color: 'rgba(0, 0, 0, 0.85)',
      fontWeight: 400,
    },
    radioGroupContainer: {
      '&:not(:last-child)': {
        marginBottom: '12px',
      },
    },
    inputContainer: {
      padding: '12px',
      position: 'relative',
      width: '100%',
    },
    searchInput: {
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: theme.borderRadius.min,
      color: '#4c4c4c',
      fontSize: '14px',
      height: '32px',
      lineHeight: '22px',
      margin: '0',
      outline: 0,
      padding: '5px 22px 5px 8px',
      width: '100%',
      appearance: 'none',
      '&::placeholder': {
        fontSize: '14px',
        color: 'rgba(0,0,0,.15)',
      },
      '&:focus': {
        borderColor: theme.colors.mainGreen6,
      },
    },
    searchIcon: {
      color: theme.colors.disableColor,
      position: 'absolute',
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      fontStyle: 'normal',
      lineHeight: '0',
      textAlign: 'center',
      marginRight: '8px',
    },
    filterDropdownBox: {
      minWidth: '240px',
      paddingTop: '4px',
      maxHeight: '328px',
      '& .ant-checkbox-group': {
        width: '100%',
        maxHeight: 320,
        paddingTop: '4px',
        paddingBottom: '4px',
        overflowY: 'auto',
      },

      '& .ant-checkbox-wrapper': {
        display: 'block',
        margin: '0',
        paddingLeft: '12px',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontSize: '14px',
        lineHeight: '22px',
        maxWidth: '240px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 400,
        '&:hover': {
          backgroundColor: theme.colors.gray3,
        },
      },
      '& .ant-checkbox-wrapper-checked': {
        backgroundColor: `${theme.colors.mainGreen1} !important`,
        color: theme.colors.mainGreen6,
      },
      '& .ant-radio-group': {
        width: '100%',
        maxHeight: 320,
        overflowY: 'auto',
      },

      '& .ant-radio-wrapper': {
        display: 'block',
        margin: '0',
        paddingLeft: '12px',
        paddingTop: '4px',
        paddingBottom: '4px',
        fontSize: '14px',
        lineHeight: '22px',
        maxWidth: '240px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color: 'rgba(0, 0, 0, 0.85)',
        fontWeight: 400,
        '&:hover': {
          backgroundColor: theme.colors.gray3,
        },
      },
      '& .ant-radio-wrapper-checked': {
        color: theme.colors.mainGreen6,
      },
    },
    loading: {
      padding: '10px',
    },
  }),
  { name: 'newSearch' },
);
